import { css } from '@emotion/react';
import styled from '@emotion/styled';
export const FramelessPanelSection = styled.section `
  width: 100%;
  height: 100%;
  overflow: auto;
  overscroll-behavior: auto;
  ${({ backgroundColor }) => css `
    background-color: ${backgroundColor} !important;
  `}
`;
